import { api } from "../../../api/api";
import { functions, saveData } from "../../../tools/functions";
import { contacts } from "../../../actions/contacts";
import { apiCampaign } from "../../../api/campaign/apiCampaign";
import { app } from "../../../actions/app";
import { campaign } from "../../../actions/campaign";
import { linkedInProfileOpener } from "../../../api/linkedInProfileOpener";
import { mapping } from "../../../actions/mapping";
import store from "../../../redux/store.ts";
import { notificationUtils } from "features/notifications/index.ts";
import { notifyError } from "shared/errors/notificate.ts";
import { executionsUtils } from "features/executions/index.ts";

export function onClearAllClick() {
  const newContacts =
    this.props.type === "add-to-campaign"
      ? this.state.contactsModal
      : this.state.contacts;

  for (const contact of newContacts) {
    setNewDataUnChecked.call(this, contact.id);
  }

  this.setState({
    selected: [],
    selectedValues: 0,
    selectAllUsersValue: false,
  });
}

export function onSelectAllClick() {
  const newContacts =
    this.props.type === "add-to-campaign"
      ? this.state.contactsModal
      : this.state.contacts;
  const newContactsCount =
    this.props.type === "add-to-campaign"
      ? this.props.contactsCountModal
      : this.props.contactsCount;
  const newSelected = newContacts.map((item) => item.id);

  for (const contact of newContacts) {
    setNewDataChecked.call(this, contact.id);
  }

  this.setState({
    selected: newSelected,
    selectedValues: newContactsCount,
    selectAllUsersValue: true,
  });
}

export function createFilter() {
  const result =
    this.props.history.location.pathname !== "/contacts"
      ? this.props.filters.filtersQuery
        ? this.props.filters.filtersQuery
        : `tags/any(c:c eq '${this.props.activeImportId}')`
      : this.props.filters.filtersQuery;
  return result;
}

export function createCriteriaForSelectedContacts() {
  const selectId = this.state.selected;
  const filterContacts = createFilter.call(this);
  const filterImport = `id in (${selectId.map((item) => `'${item}'`)})`;
  const result = {
    filter: this.state.selectAllUsersValue ? filterContacts : filterImport,
    keywords: this.props.keywords ? this.props.keywords : "",
    orderby:
      this.props.history.location.pathname === "/contacts"
        ? this.props.isFiltering
        : this.props.isFiltering,
  };
  return result;
}

export function getNewPage() {
  const getNewPage =
    this.props.type === "add-to-campaign"
      ? this.props.contactsPageModal
      : this.props.contactsPage;
  const newContactsCount =
    this.props.type === "add-to-campaign"
      ? this.props.contactsCountModal
      : this.props.contactsCount;
  let newPage =
    getNewPage * this.state.initialValuePagination >=
      newContactsCount - this.state.initialValuePagination &&
    getNewPage * this.state.initialValuePagination === newContactsCount
      ? getNewPage - 1
      : getNewPage;
  return (newPage = newPage >= 0 ? newPage : 0);
}

export async function previewContacts() {
  try {
    const data = createCriteriaForSelectedContacts.call(this);
    const preview = await api.previewContacts(data);

    if (preview.status === 200) {
      if (preview.data?.validation_rules_summary.length === 0) {
        this.setState({ isDeleteContactsOpened: true });
      } else {
        return this.setState({
          confirmationDialogContacts: {
            status: true,
            data: preview.data,
          },
        });
      }
      getNewPage.call(this);
    }
  } catch (error) {
    notifyError(error);
  }
}

export async function exportRecentActivities() {
  const selectedIds = this.state.selected;
  const filterExpression = this.state.selectAllUsersValue
    ? this.props.filterQueryExecutions
      ? this.props.filterQueryExecutions
      : `(campaign_id eq  '${this.props.campaignId}')`
    : `id in (${selectedIds.map((item) => `'${item}'`)})`;

  const queryParameters = {
    filter: filterExpression,
    keywords: this.props.keywordsExecutions
      ? this.props.keywordsExecutions
      : "",
  };

  try {
    this.setState({ isLoadingInteractionLog: true });
    const response = await api.exportRecentActivitiesApi(queryParameters);
    if (response.status === 200) {
      const data = response.data,
        fileName = functions.getFileName();
      saveData(data, fileName);
    }
  } catch (error) {
    notifyError(error);
  } finally {
    this.setState({
      selected: [],
    });
    this.setState({ isLoadingInteractionLog: false });
  }
}

export async function removeExecutionsFromCampaign() {
  this.props.setIsExcludeLoader(true);
  await apiCampaign.removeExecutionsFromCampaignApi({
    filter:
      this.state.selectAllUsersValue && this.props.filterQueryExecutions
        ? `${this.props.filterQueryExecutions}${
            this.props.keywordsExecutions
              ? "&$searchQuery=" + this.props.keywordsExecutions
              : ""
          }`
        : this.state.selectAllUsersValue
          ? `campaign_id eq '${this.props.campaignId}'${
              this.props.keywordsExecutions
                ? "&$searchQuery=" + this.props.keywordsExecutions
                : ""
            }`
          : `id in (${this.state.selected.map((item) => `'${item}'`)})`,
  });

  executionsUtils.refetch();

  const newPage = getNewPage.call(this);

  await contacts.getContacts({
    take: this.state.initialValuePagination,
    skip: newPage * this.state.initialValuePagination,
    orderby: this.props.isFiltering ? this.props.isFiltering : "created asc",
    status: "Running",
    filter:
      this.props.filterQueryExecutions || this.props.keywordsExecutions
        ? `${
            this.props.filterQueryExecutions
              ? this.props.filterQueryExecutions
              : ""
          }${
            this.props.keywordsExecutions
              ? "&$searchQuery=" + this.props.keywordsExecutions
              : ""
          }`
        : `campaign_id eq '${this.props.campaignId}'`,
  });
  this.setState({
    selected: [],
  });
  this.props.setIsExcludeLoader(false);
  notificationUtils.snackById("3.16");
}

export async function exportContactsForCampaign() {
  const selectId = this.state.selected;
  const filterCompose = this.state.selectAllUsersValue
    ? `campaigns/any(c:c eq '${this.props.match.params.id}')`
    : `id in (${selectId.map((item) => `'${item}'`)})`;
  const filterNoCompose = this.state.selectAllUsersValue
    ? this.props.filterQueryExecutions
      ? this.props.filterQueryExecutions
      : `(campaign_id eq  '${this.props.campaignId}')`
    : `id in (${selectId.map((item) => `'${item}'`)})`;

  const dataCompose = {
    filter: filterCompose,
    orderby: this.props.isFiltering ? this.props.isFiltering : "created asc",
  };
  const dataExecutions = {
    filter: filterNoCompose,
    orderby: this.props.isFilteringExecutions.includes("import")
      ? "created asc"
      : this.props.isFilteringExecutions,
    keywords: this.props.keywordsExecutions
      ? this.props.keywordsExecutions
      : "",
  };

  try {
    this.setState({ isLoadingCSVCampaigns: true });
    const response =
      this.props.campaignStatus === "Compose"
        ? await api.exportContactsApi(dataCompose)
        : await api.exportContactsApiExecutions(dataExecutions);
    if (response.status === 200) {
      const data = response.data,
        fileName = functions.getFileName();
      saveData(data, fileName);
    }
  } catch (error) {
    notifyError(error);
  } finally {
    this.setState({
      selected: [],
    });
    this.setState({ isLoadingCSVCampaigns: false });
  }
}

export function areDisabledSelectionActions() {
  const result = this.state.selected.length === 0;
  return result;
}

export async function deleteContacts() {
  const newPage =
    this.props.type === "add-to-campaign"
      ? this.props.contactsPageModal
      : this.props.contactsPage;
  this.setState({ isDeleteContactsOpened: false });
  app.changePageContentLoaderStatus(true);
  try {
    const data = createCriteriaForSelectedContacts.call(this);
    await api.deleteContacts(data);
    const criteria = {
      take: this.state.initialValuePagination,
      skip: newPage * this.state.initialValuePagination,
      filter: createFilter.call(this),
      keywords: this.props.filters.searchQuery
        ? this.props.filters.searchQuery
        : "",
      orderby: this.props.isFiltering ? this.props.isFiltering : "",
    };

    let response = await contacts.getContacts(criteria);
    if (
      response.status === 200 &&
      response.data.documents.length === 0 &&
      response.data.total > 0
    ) {
      criteria.skip -= this.state.initialValuePagination;
      response = await contacts.getContacts(criteria);
    }

    if (response.status === 200) {
      notificationUtils.snackById("3.20");
    }
  } catch (error) {
    notifyError(error);
  } finally {
    this.setState({
      selected: [],
    });
    app.changePageContentLoaderStatus(false);
  }
}

export async function exportContacts() {
  const data = createCriteriaForSelectedContacts.call(this);
  try {
    this.setState({ isLoadingCSV: true });
    const response = await api.exportContactsApi(data);
    if (response.status === 200) {
      const data = response.data,
        fileName = functions.getFileName();
      saveData(data, fileName);
    }
  } catch (error) {
    notifyError(error);
  }
  clearCheckboxes.call(this);
  this.setState({ isLoadingCSV: false });
}

export function clearCheckboxes() {
  const newContacts =
    this.props.type === "add-to-campaign"
      ? this.state.contactsModal
      : this.state.contacts;

  for (const contact of newContacts) {
    setNewDataUnChecked.call(this, contact.id);
  }

  this.setState({
    selected: [],
    selectedValues: 0,
  });
}

export function setNewDataUnChecked(id) {
  var rowNode = this.state.gridApi.getRowNode(id);
  var newData = this.state.rowData?.find((item) => item.id === id);
  newData.isSelected = false;
  rowNode.setDataValue("select", false);
}

export function setNewDataChecked(id) {
  var rowNode = this.state.gridApi.getRowNode(id);
  var newData = this.state.rowData?.find((item) => item.id === id);
  newData.isSelected = true;
  rowNode.setDataValue("select", true);
}

export function setNewData(id) {
  var rowNode = this.state.gridApi.getRowNode(id);
  var newData = this.state.rowData?.find((item) => item.id === id);
  newData.isSelected = !newData.isSelected;
  rowNode.setDataValue("select", newData?.isSelected);
}

export function handleClick(id) {
  const selectedIndex = this.state.selected.indexOf(id);
  let newSelected = [];

  if (selectedIndex === -1) {
    newSelected = newSelected.concat(this.state.selected, id);
  } else if (selectedIndex === 0) {
    this.setState({
      selectAllUsersValue: false,
    });
    newSelected = newSelected.concat(this.state.selected.slice(1));
  } else if (selectedIndex === this.state.selected.length - 1) {
    this.setState({
      selectAllUsersValue: false,
    });
    newSelected = newSelected.concat(this.state.selected.slice(0, -1));
  } else if (selectedIndex > 0) {
    this.setState({
      selectAllUsersValue: false,
    });
    newSelected = newSelected.concat(
      this.state.selected.slice(0, selectedIndex),
      this.state.selected.slice(selectedIndex + 1)
    );
  }
  setNewData.call(this, id);
  this.setState({
    selected: newSelected,
    selectedValues: newSelected.length,
  });
}

export function onSelectAllPageClick(isChecked) {
  const newContacts =
    this.props.type === "add-to-campaign"
      ? this.state.contactsModal
      : this.state.contacts;
  if (isChecked) {
    for (const contact of newContacts) {
      setNewDataChecked.call(this, contact.id);
    }

    this.setState({
      selected:
        this.props.type === "add-to-campaign"
          ? this.props.contactsModal?.map((contact) => contact.id)
          : this.props.contacts?.map((contact) => contact.id),
      selectedValues: newContacts.length,
    });
  } else {
    for (const contact of newContacts) {
      setNewDataUnChecked.call(this, contact.id);
    }

    this.setState({
      selected: [],
      selectedValues: 0,
    });
  }
}

export async function handlerCompleteExecutions(id) {
  try {
    app.changeTableContentLoaderStatus(true);
    const response = await api.setExecutionComplete(id);
    executionsUtils.refetch();
    if (response.status === 200) {
      const campaignExecutionsId = response.data.id;
      const executionIndex =
        this.props.type === "add-to-campaign"
          ? this.props.contactsModal.findIndex((item) => {
              return item.campaignExecutions.id === campaignExecutionsId;
            })
          : this.props.contacts.findIndex((item) => {
              return item.campaignExecutions.id === campaignExecutionsId;
            });
      const tempContacts =
        this.props.type === "add-to-campaign"
          ? this.props.contactsModal
          : this.props.contacts;
      tempContacts[executionIndex].campaignExecutions = response.data;
      contacts.cancelExecution(tempContacts);
    }
    await campaign.getCampaignId(this.props.match.params.id);
  } catch (error) {
    notifyError(error);
  } finally {
    app.changeTableContentLoaderStatus(false);
  }
}

export async function removeContactsFromCampaign(audience, campaignId) {
  if (this.state.selectAllUsersValue) {
    await campaign.removeAllContactsFromCampaign({
      campaignId,
    });
  } else {
    await campaign.removeContactsFromCampaign({
      campaignId,
      filter: `id in (${audience.map((item) => `'${item}'`)})`,
      audience,
    });
  }

  const newPage = getNewPage.call(this);
  await contacts.getContacts({
    take: this.state.initialValuePagination,
    skip: newPage * this.state.initialValuePagination,
    filter: `campaigns/any(c:c eq '${campaignId}')`,
    orderby: this.props.isFiltering ? this.props.isFiltering : "imported asc",
  });
  this.setState({
    selected: [],
  });
  await campaign.getCampaignId(campaignId);
}

export function onGridReady(params) {
  this.setState({
    gridApi: params.api,
    gridColumnApi: params.columnApi,
  });
}

export function dropDownController(value) {
  this.setState({
    dropDownController: value,
  });
}

export function dropDownControllerContact(value) {
  this.setState({
    dropDownControllerContact: value,
  });
}

export async function getContactsBySort() {
  if (this.props.type === "single" && this.props.campaignStatus !== "Compose") {
    contacts.getContacts({
      status: "Active",
      skip: 0,
      take: this.state.initialValuePagination,
      filter: this.props.filterQueryExecutions
        ? this.props.filterQueryExecutions
        : [`campaign_id eq '${this.props.match.params.id}'`],
      orderby: this.props.isFilteringExecutions.includes("created")
        ? this.props.isFilteringExecutions
        : this.props.isFilteringExecutions,

      keywords: this.props.keywordsExecutions
        ? this.props.keywordsExecutions
        : "",
    });
  }
  if (this.props.type === "single" && this.props.campaignStatus === "Compose") {
    contacts.getContacts({
      take: this.state.initialValuePagination,
      skip: 0,
      filter: `campaigns/any(c:c eq '${this.props.campaignId}')`,
      orderby: this.props.isFiltering,
    });
  }
  if (this?.props?.history?.location?.pathname.includes("/import")) {
    contacts.getContacts({
      take: this.state.initialValuePagination,
      orderby: this.props.isFiltering,
      skip: 0,
      filter: this.props.filters.filtersQuery
        ? this.props.filters.filtersQuery
        : `tags/any(c:c eq '${this.props.match.params.id}')`,
      keywords: this.props.keywords || this.props.filters.searchQuery || "",
    });
  }
  if (this?.props?.history?.location?.pathname === "/contacts") {
    contacts.getContacts({
      take: this.state.initialValuePagination,
      orderby:
        this.props.history.location.pathname === "/contacts" ||
        this.props.history.location.pathname.includes("/campaigns")
          ? this.props.isFiltering
          : "imported asc",
      filter: this?.props?.filters?.filtersQuery
        ? this.props.filters.filtersQuery
        : "",
      keywords: this.props.keywords || this.props.filters.searchQuery || "",
    });
  }
  contacts.changeContactsPage(0);
}

export async function getContactsOnPage() {
  return this.props.type === "add-to-campaign"
    ? this.props.contactsModal
    : this.props.contacts;
}

export async function handleChangePage(events, newPage) {
  try {
    if (this.props.match.params.id) {
      if (this.props.type === "add-to-campaign") {
        contacts.changeContactsPageModal(newPage);
        const filter = this.props.filters.filtersQueryForModal
          ? this.props.filters.filtersQueryForModal
          : `not (campaigns/any(c:c eq '${this.props.match.params.id}'))`;
        const response = await contacts.getContacts(
          {
            take: this.state.initialValuePagination,
            skip: newPage > 0 ? newPage * this.state.initialValuePagination : 0,
            filter,
            keywords: this.props.keywords ? this.props.keywords : "",
            orderby: this.props.isFiltering
              ? this.props.isFiltering
              : "imported desc",
          },
          undefined,
          undefined,
          false,
          true
        );
        if (response.data) {
          if (response.data.documents.length > 0) {
            contacts.haveContacts(true);
            store.dispatch({
              type: "CONTACTS_COUNT_MODAL",
              payload: {
                contactsCountModal: response.data.total,
              },
            });
          }
          store.dispatch({
            type: "ALL_CONTACTS_MODAL",
            payload: {
              contactsModal: mapping.buildContacts(response.data.documents),
            },
          });
          app.changePageContentLoaderStatus(false);
          app.changeTableContentLoaderStatus(false);
        }
        return;
      }
      if (
        this.props.type === "single" &&
        this.props.campaignStatus === "Compose"
      ) {
        contacts.changeContactsPage(newPage);
        contacts.getContacts(
          {
            take: this.state.initialValuePagination,
            skip: newPage > 0 ? newPage * this.state.initialValuePagination : 0,
            filter: `campaigns/any(c:c eq '${this.props.match.params.id}')`,
            orderby: this.props.isFiltering
              ? this.props.isFiltering
              : "imported asc",
          },
          this.props.campaignStatus,
          this.props.match.params.id
        );
        return;
      }
      if (
        this.props.type === "single" &&
        this.props.campaignStatus !== "Compose"
      ) {
        contacts.changeContactsPage(newPage);
        contacts.getContacts(
          {
            take: this.state.initialValuePagination,
            skip: newPage > 0 ? newPage * this.state.initialValuePagination : 0,
            filter: this.props.filterQueryExecutions
              ? this.props.filterQueryExecutions
              : [`campaign_id eq '${this.props.match.params.id}'`],
            orderby: this.props.isFilteringExecutions
              ? this.props.isFilteringExecutions
              : "created asc",
            keywords: this.props.keywordsExecutions
              ? this.props.keywordsExecutions
              : "",
          },
          this.props.campaignStatus
        );
        return;
      }
      contacts.changeContactsPage(newPage);
      contacts.getContacts({
        take: this.state.initialValuePagination,
        orderby: this.props.isFiltering
          ? this.props.isFiltering
          : "imported asc",
        skip: newPage > 0 ? newPage * this.state.initialValuePagination : 0,
        filter: this.props.filters.filtersQuery
          ? this.props.filters.filtersQuery
          : `tags/any(c:c eq '${this.props.match.params.id}')`,
        keywords: this.props.filters.searchQuery
          ? this.props.filters.searchQuery
          : this.props.keywords
            ? this.props.keywords
            : "",
      });
    } else {
      contacts.changeContactsPage(newPage);
      contacts.getContacts({
        take: this.state.initialValuePagination,
        skip: newPage > 0 ? newPage * this.state.initialValuePagination : 0,
        filter: this.props.filters.filtersQuery
          ? this.props.filters.filtersQuery
          : "",
        keywords: this.props.keywords ? this.props.keywords : "",
        orderby: this.props.isFiltering ? this.props.isFiltering : "",
      });
    }
    this.setState({
      contactsOnPage: getContactsOnPage.call(this, newPage),
    });
  } catch (error) {
    notifyError(error);
  }
}

export async function onClickExclude() {
  let preview = "";
  if (this.state.isCampaignsRunning) {
    this.setState({
      needLoader: true,
    });
    preview = await apiCampaign.getPreviewRemoveTargetAudience({
      filter:
        this.state.selectAllUsersValue && this.props.filterQueryExecutions
          ? `${this.props.filterQueryExecutions}${
              this.props.keywordsExecutions
                ? "&$searchQuery=" + this.props.keywordsExecutions
                : ""
            }`
          : this.state.selectAllUsersValue
            ? `campaign_id eq '${this.props.campaignId}'${
                this.props.keywordsExecutions
                  ? "&$searchQuery=" + this.props.keywordsExecutions
                  : ""
              }`
            : `id in (${this.state.selected.map((item) => `'${item}'`)})`,
    });
    this.setState({
      needLoader: false,
    });
  }

  if (
    preview &&
    ((this.props.campaignStatus === "Running" &&
      preview?.data?.validation_rules_summary?.length === 0) ||
      (this.props.campaignStatus === "Stopped" &&
        preview?.data?.validation_rules_summary?.length === 0) ||
      (this.props.campaignStatus === "Completed" &&
        preview?.data?.validation_rules_summary?.length === 0) ||
      (preview?.data?.validation_rules_summary?.length === 0 &&
        preview?.data?.valid_audience_count > 0))
  ) {
    this.setState({ isExcludeContactsOpened: true });
  } else {
    return this.setState({
      confirmationDialog: {
        id: this.state.companyId,
        status: true,
        data: preview.data,
      },
    });
  }
}

export async function deleteHandler() {
  this.setState({ isExcludeContactsOpened: false });
  if (this.state.isCampaignsRunning) {
    removeExecutionsFromCampaign.call(
      this,
      this.state.selected,
      this.props.campaignId
    );
  } else {
    removeContactsFromCampaign.call(
      this,
      this.state.selected,
      this.props.campaignId
    );
  }
}

export function createDataArray(colState) {
  return [
    {
      colId: "select",
      width: colState.find((el) => el.colId === "select").width,
      hide: false,
      title: "Select",
    },

    {
      colId: "contact",
      width: colState.find((el) => el.colId === "contact").width,
      hide: false,
      title: "Contact",
    },
    {
      colId: "headline",
      width: colState.find((el) => el.colId === "headline").width,
      hide: colState.find((el) => el.colId === "headline").hide,
      title: "Headline",
    },
    {
      colId: "location",
      width: colState.find((el) => el.colId === "location").width,
      hide: colState.find((el) => el.colId === "location").hide,
      title: "Location",
    },
    {
      colId: "status",
      width: colState.find((el) => el.colId === "status").width,
      hide: colState.find((el) => el.colId === "status").hide,
      title: "Status",
    },
    {
      colId: "lastAction",
      width: colState.find((el) => el.colId === "lastAction").width,
      hide: colState.find((el) => el.colId === "lastAction").hide,
      title: "Last Action",
    },
    {
      colId: "added",
      width: colState.find((el) => el.colId === "added").width,
      hide: colState.find((el) => el.colId === "added").hide,
      title: "Added",
    },
    {
      colId: "custom1",
      width: colState.find((el) => el.colId === "custom1").width,
      hide: colState.find((el) => el.colId === "custom1").hide,
      title: "Custom 1",
    },
    {
      colId: "custom2",
      width: colState.find((el) => el.colId === "custom2").width,
      hide: colState.find((el) => el.colId === "custom2").hide,
      title: "Custom 2",
    },
    {
      colId: "custom3",
      width: colState.find((el) => el.colId === "custom3").width,
      hide: colState.find((el) => el.colId === "custom3").hide,
      title: "Custom 3",
    },
  ];
}

export function createDataArrayAll(colState) {
  return [
    {
      colId: "select",
      width: colState.find((el) => el.colId === "select").width,
      hide: colState.find((el) => el.colId === "select").hide,
      title: "Select",
    },

    {
      colId: "contact",
      width: colState.find((el) => el.colId === "contact").width,
      hide: colState.find((el) => el.colId === "contact").hide,
      title: "Contact",
    },
    {
      colId: "headline",
      width: colState.find((el) => el.colId === "headline").width,
      hide: colState.find((el) => el.colId === "headline").hide,
      title: "Headline",
    },
    {
      colId: "location",
      width: colState.find((el) => el.colId === "location").width,
      hide: colState.find((el) => el.colId === "location").hide,
      title: "Location",
    },
    {
      colId: "lastAction",
      width: colState.find((el) => el.colId === "lastAction").width,
      hide: colState.find((el) => el.colId === "lastAction").hide,
      title: "Last Action",
    },
    {
      colId: "imported",
      width: colState.find((el) => el.colId === "imported").width,
      hide: colState.find((el) => el.colId === "imported").hide,
      title: "Imported",
    },
    {
      colId: "created",
      width: colState.find((el) => el.colId === "created").width,
      hide: colState.find((el) => el.colId === "created").hide,
      title: "Created",
    },
    {
      colId: "custom1",
      width: colState.find((el) => el.colId === "custom1").width,
      hide: colState.find((el) => el.colId === "custom1").hide,
      title: "Custom 1",
    },
    {
      colId: "custom2",
      width: colState.find((el) => el.colId === "custom2").width,
      hide: colState.find((el) => el.colId === "custom2").hide,
      title: "Custom 2",
    },
    {
      colId: "custom3",
      width: colState.find((el) => el.colId === "custom3").width,
      hide: colState.find((el) => el.colId === "custom3").hide,
      title: "Custom 3",
    },
  ];
}

export function saveState() {
  if (this.state.gridColumnApi) {
    const colState = this.state.gridColumnApi.getColumnState();
    const data =
      this.props.type === "single"
        ? createDataArray.call(this, colState)
        : createDataArrayAll.call(this, colState);

    this.setState({
      data,
    });
    contacts.columnSize(data);
    contacts.typeContacts(this.props.type);
    contacts.typeCampaigns(this.props.campaignStatus);
    this.SavedColState.current = colState;
    this.state.gridColumnApi.applyColumnState({
      state: data,
    });

    this.state.type === "single"
      ? localStorage.setItem("executionsGridSettings", JSON.stringify(data))
      : localStorage.setItem("contactsGridSettings", JSON.stringify(data));
  }
}

export function onColumnResized(event) {
  if (event.finished && event.source !== "flex") {
    if (this.state.gridColumnApi) {
      saveState.call(this);
    }
  }
}

export const heightGenerator = (type) => {
  switch (type) {
    case "add-to-campaign":
      return "calc(100vh - 255px)";
    case "all":
      return "calc(100vh - 240px)";
    case "single":
      return "calc(100vh - 240px)";
    case "compose":
      return "calc(100vh - 195px)";

    default:
      return "calc(100vh - 240px)";
  }
};

export const getStylePagination = (isOpenMenuPagination) => ({
  control: (base) => {
    return {
      ...base,
      "&:hover": {
        border: isOpenMenuPagination
          ? "1px solid #0cb39f"
          : "1px solid  #EBEDF2",
      },
      border: isOpenMenuPagination ? "1px solid #0cb39f" : "1px solid  #EBEDF2",
      boxShadow: "",
      fontWeight: 400,
      fontSize: 14,
      background: "#FFF",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      opacity: "1",
      color: "#202020",
      width: "150px",
      cursor: "pointer",
      minHeight: "32px",
    };
  },
  indicatorsContainer: (base) => ({
    ...base,
    borderLeft: isOpenMenuPagination
      ? "1px solid #0cb39f"
      : "1px solid  #EBEDF2",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    backgroundColor: "transparent",
    paddingTop: "5px",
    paddingBottom: "5px",
  }),
  singleValue: (base) => ({
    ...base,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    padding: "5px   3px",
    height: "32px",
    color: "#202020",
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: "32px",
  }),
  option: (styles, { isSelected }) => ({
    ...styles,
    fontSize: 14,
    color: "#000",
    backgroundColor: isSelected ? "#F7F7F7" : "transparent",
    "&:active": {
      backgroundColor: "transparent",
    },
    "&:hover": { backgroundColor: "#F7F7F7", cursor: "pointer" },
  }),
  menuList: (base) => ({
    ...base,
    position: "absolute",
    left: "-1px",
    bottom: "34px",
    backgroundColor: "#fff",
    width: "150px",
    border: "1px solid #0cb39f",
    borderBottom: "1px solid transparent",
  }),
  menu: (base) => ({
    ...base,
    boxShadow: "",
    marginTop: 0,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderTop: 0,
  }),
});

export function getInitialWidth(colId, isSingle) {
  const dataSizeTable = !isSingle
    ? JSON.parse(localStorage?.getItem("contactsGridSettings"))
    : JSON.parse(localStorage?.getItem("executionsGridSettings"));
  const column = dataSizeTable?.find((el) => el.colId === colId);
  return column ? column.width : null;
}

export function getColumnProperty(colId, defaultValue, isSingle) {
  const dataSizeTable = !isSingle
    ? JSON.parse(localStorage?.getItem("contactsGridSettings"))
    : JSON.parse(localStorage?.getItem("executionsGridSettings"));
  const column = dataSizeTable?.find((el) => el.colId === colId);
  return column ? column.hide : defaultValue;
}
export function getInitialWidthOrFlex(colId, defaultWidth, isSingle) {
  const width = getInitialWidth(colId, defaultWidth, isSingle);
  return width !== null ? { width } : { flex: 1 };
}
export function getInitialWidthOrFlexSmall(colId, defaultWidth, isSingle) {
  const width = getInitialWidth(colId, defaultWidth, isSingle);
  return width !== null ? { width } : { flex: 0.5 };
}

export function transformContactsData(avatarSvg) {
  const newContacts =
    this.props.type === "add-to-campaign"
      ? this.props.contactsModal
      : this.props.contacts;

  return newContacts.map((row) => ({
    id: row.id,
    isSelected: this.state?.selected?.includes(row.id) || false,
    contact: {
      avatar: row.avatar ? row.avatar : avatarSvg,
      fullName: row.fullName,
      connection: row.connection,
      account: row.account,
      openLinkedInProfile: () => linkedInProfileOpener.open(row),
    },
    headline: row.position,
    status:
      row.campaignExecutions &&
      this.renderSteps(
        row.campaignExecutions.step_executions,
        row.campaignExecutions
      ),
    location: row.location,
    lastAction: functions.parseDateToDMY(row.contacted, "/"),
    imported: functions.parseDateToDMY(row.date, "/"),
    created: functions.parseDateToDMY(row.created, "/"),
    added: row.campaignExecutions?.created
      ? functions.parseDateToDMY(row.campaignExecutions.created, "/")
      : functions.parseDateToDMY(row.created, "/"),
    campaignExecutions: row.campaignExecutions,
    actions: row.actions,
    fullName: row.fullName,
    publicIdentifier: row.publicIdentifier,
    position: row.position,
    contacted: row.contacted,
    connection: row.connection,

    account: row.account,
    avatar: row.avatar,
    entityId: row.entityId,
    custom1: row.customField1,
    custom2: row.customField2,
    custom3: row.customField3,
  }));
}
